import { EModules } from '../../../shared/enums/modules/EModules';
import { IModule } from '../../../shared/interfaces/modules/IModule';
import { requests } from '../../../utils/api/api.service';
import { MODULE_URL } from '../../../utils/api/endpoints';

export interface IModuleFilter {
  name: string;
}

export const DeveloperModuleService = {
  getAll: (payload: IModuleFilter): Promise<IModule[]> =>
    requests.get(MODULE_URL, payload),
  update: (moduleName: EModules): Promise<IModule> =>
    requests.put(`${MODULE_URL}/${moduleName}/toggle`, {}),
};
